<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-100">
			<md-card class="card-table">
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="md-layout">
						<div class="md-layout-item">
							<div class="card-icon">
								<i class="md-icon fas fa-layer-group"/>
							</div>
							<h4 class="title">Liste des modèles de fiche de suivi des dispositifs</h4>
						</div>
						<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
							<div class="flex items-center">
								<div class="mr-2">
									<md-button class="md-info md-sm md-button-action"
											   @click="goToRoute('Insects')">
										<md-icon class="material-icons mr-1">add</md-icon>
										<span>Insectes</span>
									</md-button>
								</div>
								<div>
									<md-button class="md-info md-sm md-button-action"
											   @click="goToRoute('')">
										<md-icon class="material-icons mr-1">add</md-icon>
										<span>Ajouter un modèle de fiche de suivi</span>
									</md-button>
								</div>
							</div>
						</div>
					</div>
				</md-card-header>
                <md-card-content>
                    <md-table
                        :value="deviceReportTypes"
                        class="paginated-table table-hover"
                    >
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="#" style="max-width: 75px;">
                                {{ item.id }}
                            </md-table-cell>
                            <md-table-cell md-label="Nom" style="max-width: 100px;">
                                {{ item.name }}
                            </md-table-cell>
                            <md-table-cell md-label="Version" style="max-width: 400px; width: 400px;">
                                {{ item.version }}
                            </md-table-cell>
                            <md-table-cell md-label="" style="max-width: 75px;">
                                <md-button class="md-info py-0" @click="goToRoute('Report Type Details', item.id)">Voir le modèle</md-button>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "ReportTypes",
    data() {
	    return {
	        deviceReportTypes : []
        }
    },
	methods: {
        async getReportTypes() {
            const { data } = await this.$store.dispatch('deviceReportTypes/getDeviceReportTypes')
            this.deviceReportTypes = data
        },
		goToRoute(route, id = null) {
			this.$router.push({ name: route, params: { id }})
		}
	},
    mounted() {
	    this.getReportTypes()
    }
}
</script>

<style scoped lang="scss">

</style>
